import {Component, OnInit} from '@angular/core';
import {User, UserType} from '../../../../services/api.client';
import {Observable} from 'rxjs';
import {SecurityService} from '../../../../services/SecurityService';

@Component({
    templateUrl: './PledgesReportComponent.html',
    standalone: false
})
export class PledgesReportComponent implements OnInit {
  userTypes = UserType;
  currentUser: User;
  currentUser$: Observable<User>;

  constructor(private _securityService: SecurityService) {
    this.currentUser$ = this._securityService.currentUser$;
  }

  ngOnInit(): void {
    this.currentUser$.subscribe(user => this.currentUser = user);
  }
}
